import { useState, useEffect } from "react";

const PlaylistThumb = (props) => {
  const {
    playlist,
    setActivePlaylist,
    setPlaylistOverlayOpen,
  } = props;

    function replaceAfterLastHyphen(url) {
      const lastHyphenIndex = url.lastIndexOf("-");
      if (lastHyphenIndex === -1) return url;
      return url.slice(0, lastHyphenIndex + 1) + "t500x500.jpg";
    }
  
    const [imageUrl, setImageUrl] = useState();
  
    useEffect(() => {
      if (playlist.artworkUrl) {
        setImageUrl(replaceAfterLastHyphen(playlist.artworkUrl));
      }
    }, [playlist]);

  return (
    <button
      className="playlist__thumb-wrapper"
      onClick={() => {
        setActivePlaylist(playlist);
        setPlaylistOverlayOpen(true);
      }}
    >
      <img
        src={imageUrl}
        alt={playlist.title}
        className="playlist__thumb"
      />
      <div className="playlist__thumb-title">{playlist.title}</div>
    </button>
  );
};

export default PlaylistThumb;
